(function() {
    const scrollToTopBtn = document.querySelector('.jsScrollToTopBtn');
    if (scrollToTopBtn) {
        setClassname();
        window.addEventListener('scroll', _ => setClassname());

        scrollToTopBtn.addEventListener('click', e => {
            e.preventDefault();
            window.scrollTo({top: 0, behavior: 'smooth'});
        });

        function setClassname() {
            if (window.scrollY > 800) {
                scrollToTopBtn.classList.add('visible');
                document.body.classList.add('scroll-to-top-visible');
            }
            else {
                scrollToTopBtn.classList.remove('visible');
                document.body.classList.remove('scroll-to-top-visible');
            }
        }
    }
})();
